import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import SaveHealthCenterBody from "components/ClinicalManagement/HealthCenters/Details/SaveHealthCenter/SaveHealthCenterBody";

const SaveHealthCenter = () => {
  useEffect(() => {
    document.title = "Save Health Center";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <SaveHealthCenterBody />
    </main>
  );
};

export default SaveHealthCenter;
